module.exports = __webpack_public_path__ + "img/aboutApp3.ada817b5.png";